var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3587",
  "data-name": "Group 3587",
  transform: "translate(-16 -400)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2296",
  "data-name": "Rectangle 2296",
  width: 16,
  height: 16,
  transform: "translate(16 400)",
  fill: "#afb6c0",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "filetext",
  transform: "translate(18 400)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M10.889,16H1.142A1.135,1.135,0,0,1,0,14.875V1.125A1.135,1.135,0,0,1,1.142,0h5.4a1.149,1.149,0,0,1,.454.1L7.01.1l.007,0,.021.01L7.1.153a1.215,1.215,0,0,1,.229.18l4.347,4.382A1.115,1.115,0,0,1,12,5.508v9.367A1.106,1.106,0,0,1,10.889,16ZM1.126,1.125v13.75h9.747V6H7.134A1.135,1.135,0,0,1,5.992,4.875V1.125Zm5.992.6v3.15H10.26Zm.454,11.4H2.566a.562.562,0,1,1,0-1.125H7.572a.562.562,0,1,1,0,1.125Zm2-2.5H2.566a.562.562,0,1,1,0-1.125H9.575a.562.562,0,1,1,0,1.125Zm-3-2.5h-4A.562.562,0,1,1,2.566,7h4a.562.562,0,1,1,0,1.125Z",
  transform: "translate(0 0)",
  fill: "#afb6c0"
})))));
export default __webpack_public_path__ + "static/media/reporting.85c5af66.svg";
export { SvgComponent as ReactComponent };